import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree} from '@angular/router';
import {AuthenticationService} from 'src/app/shared/services/authentication.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApplicationConfig} from '../classes/application-config';

@Injectable()
export class AuthenticatedUserGuard implements CanActivate {
    private authenticationService = inject(AuthenticationService);
    private router = inject(Router);

    /** Authenticates once before the application route and checks route-specific user preferences. */
    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        return this.authenticationService.ensureAuthenticated().pipe(
            map((user) => {
                if (!user || user.resettingPassword) {
                    return this.router.createUrlTree(['/login']);
                }

                if (route.data.requireUserPreferences) {
                    // If the user has no preferences set, set them to the default preferences
                    if (ApplicationConfig.currentUserPreferences.value === undefined) {
                        return this.router.createUrlTree(['/app/preferences']);
                    }
                }

                return true;
            }),
        );
    }
}
